<template>
  <div class="UserProfile" v-if="userData.userInfo.isGuest == 'no'">
      <div class="User_info">
        <b class="User_option round_img" v-on:click="isShowUserSlave = !isShowUserSlave">
          <img style="width: 40px;height: 40px;" src="../../static/images/profile/gray-user-icon3.png" alt="">
          <div class="User_name">{{this.userData.userInfo.userName}}</div>
        </b>
        <ul v-show="isShowUserSlave" class="User_club round_s">
          <em class="arrow_t_white"></em>
          <li><a class="UserData"  v-on:click="isShowUserClub=true,isShowUserSlave=false"><span class="o_arrow m_2"></span>User Data</a></li>
          <li><a class="LoginOut" v-on:click="loginOut()"><span class="o_arrow m_3"></span>Logout</a></li>
        </ul>
      </div>
      <div v-if="isShowUserClub">
        <user-club @closeClub="closeClub" v-bind:userData="userData"></user-club>
      </div>
  </div>
  <div class="UserProfile" v-else>
        <!--<a class="login_btn btn_lr" v-on:click="login">Guest</a>-->
        <div v-if="isShowLoign">
            <login @close="closeLogin" v-bind:userData="userData"></login>
        </div>
        <a class="reg_btn btn_r" v-show="'false'==='true'" v-on:click="register">Register</a>
  </div>
</template>

<script>
/* eslint-disable */
import UserClub from "@/components/UserClub";
import Login from "@/components/Login";
export default {
  name: "UserProfile",
  props: {
    userData: {
      default: ""
    }
  },
  data() {
    return {
      msg: "This is Dashboard tool bar!",
      isShowUserSlave: false,
      isShowUserClub: false,
      isShowLoign: false
    };
  },
  mounted: function() {
    this.$axios({
      // url: "http://172.18.0.169/fakeData/login.json"
      url: pfAirViewer._dataSave._baseUri + "getUser",
      method: "get",
      //headers: { 'Authorization': "Basic "},
      withCredentials: true
    }).then(this.updateUserInfo, this.errorHandle);
    /*$.get({
            url: 'http://172.18.0.169/PFNeoWebViewer/PFNeoWebViewer_BackEnd/public/data/test.json',
            beforeSend: function(xhr){xhr.setRequestHeader("Authorization", "Basic " + btoa(1 + ":" + "airbus"))},
            },function(data){
        });
        this.$axios(
            {
                url: "http://172.18.0.169/PFNeoWebViewer/PFNeoWebViewer_BackEnd/public/data/56/zx3.czml",
                method: 'get',
                //headers: { 'Authorization': "Basic " + btoa("1" + ":" + "airbus")},
                withCredentials: true
            });*/
  },
  methods: {
    login: function(event) {
      // this.isLogin = !this.isLogin;
      /*this.$axios.get(
              //"http://172.18.0.169/fakeData/login.json"
              pfAirViewer._dataSave._baseUri+"/data/httpAuth"
            ).then(this.updateUserInfo,this.errorHandle);*/
      this.$axios(
            {
                // url: "http://172.18.0.169/PFNeoWebViewer/PFNeoWebViewer_BackEnd/public/data/test.json",
                url: pfAirViewer._dataSave._baseUri+"/data/httpAuth",
                method: 'get',
                //headers: { 'Authorization': "Basic " + btoa("1" + ":" + "airbus")},
                withCredentials: true
            }).then(this.updateUserInfo,this.errorHandle);
    },
    loginOut: function() {
      //this.sendAjax();
      pfAirViewer._personLayerManager.removeAll();
      $.ajax({
        type: "GET",
        url: pfAirViewer._dataSave._baseUri + "/data/httpAuth",
        dataType: "json",
        async: false,
        xhrFields: {
          withCredentials: true
        },
        // username:"11",
        // password:"aaaaa",
        // headers: { "Authorization": "Basic xxx" }
        username: "some_username_that_doesn't_exist",
        password: "any_stupid_password"
      })
        .done(function(info) {
          console.log(info);
        })
        .fail(function(info) {
          console.log(info);
        });
      this.$axios
        .get(pfAirViewer._dataSave._baseUri + "/logout")
        .then(this.updateUserInfo, this.errorHandle);
    },
    sendAjax: function() {
      /*var xhr = new XMLHttpRequest();
      xhr.open(
        "GET",
        "http://123:123@172.18.0.169/PFNeoWebViewer/PFNeoWebViewer_BackEnd/public/data/httpAuth",
        true
      );
      //xhr.setRequestHeader('Authorization', "Basic "+btoa("123:123"));
      //Authorization: "Basic "+btoa("123:123")
      xhr.withCredentials = true;
      xhr.send();
      */
    },
    register: function() {},
    updateUserInfo: function(userInfo) {
      //debugger;
      pfAirViewer._personLayerManager.initializeData(userInfo.data.layerData);
      this.userData.userInfo = userInfo.data;
      this.isShowUserSlave = false;
      if (userInfo.data.isGuest === "yes") {
        this.login();
        return;
      }
    },
    errorHandle: function(info) {
      console.log(info);
    },
    closeClub: function() {
      this.isShowUserClub = false;
    },
    closeLogin: function() {
      this.isShowLoign = false;
    }
  },
  components: {
    UserClub,
    Login
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.UserProfile {
  float: right;
  padding-top: 0.1em;
  cursor: pointer;
}
.User_info {
  font-size: 16px;
  position: relative;
}
.round_img img {
  border-radius: 50%;
}
.User_name {
  display: inline-block;
  padding-left: 1.2em;
}
.User_option {
  display: block;
  padding-right: 1.2em;
  /*padding-bottom: .5em;*/
  position: relative;
}
.User_option::after {
  border-bottom: 2px solid rgba(255, 255, 255, 0.5);
  border-right: 2px solid rgba(255, 255, 255, 0.5);
  content: "";
  height: 6px;
  position: absolute;
  right: 0;
  top: 0.8em;
  transform: rotate(45deg);
  width: 6px;
}
.User_club {
  background: #fff none repeat scroll 0 0;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  color: #333;
  cursor: pointer;
  font-size: 14px;
  padding: 0.5em 0 0.5em 0.5em;
  position: absolute;
  right: 0;
  top: 50px;
  width: 120px;
}
.User_club li {
  float: left;
}
.User_club a {
  color: #333;
  height: 22px;
  line-height: 22px;
  padding: 2px 0 2px 0.4em;
}
.User_club a:hover {
  color: #0d5881;
}
.round_s {
  border-radius: 3px;
}
.o_arrow {
  background-image: url("../../static/images/icon/arrow.png");
  background-repeat: no-repeat;
  float: left;
  height: 22px;
  margin-right: 0.2em;
  overflow: hidden;
  width: 22px;
}
.m_2 {
  background-position: left -22px;
}
.m_3 {
  background-position: left -44px;
}
ul {
  list-style: outside none none;
}
.arrow_t_white {
  border: 70px solid transparent;
  bottom: 0;
  display: block;
  height: 0;
  position: absolute;
  width: 0;
  border-bottom-color: white;
  border-width: 5px;
  left: 40%;
  margin-left: -5px;
  top: -10px;
}

.reg_btn,
.login_btn {
  color: #fff;
  line-height: 28px;
  display: inline-block;
  vertical-align: top;
  padding: 0.1em 1em;
  margin-top: 0.2em;
  border: 1px solid #fff;
}
.reg_btn {
  border-left: none;
}
.login_btn {
  background-color: #fff;
  color: #12285f;
  margin-right: -4px;
}
.btn_lr {
  -moz-border-radius: 3px 3px 3px 3px;
  -webkit-border-radius: 3px 3px 3px 3px;
  border-radius: 3px 3px 3px 3px;
  margin-right: 8px;
}
.btn_l {
  -moz-border-radius: 3px 0 0 3px;
  -webkit-border-radius: 3px 0 0 3px;
  border-radius: 3px 0 0 3px;
}
.btn_r {
  -moz-border-radius: 0 3px 3px 0;
  -webkit-border-radius: 0 3px 3px 0;
  border-radius: 0 3px 3px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/UserProfile.vue